import { render, staticRenderFns } from "./remove-transaction-modal.vue?vue&type=template&id=650ad451&scoped=true&"
import script from "./remove-transaction-modal.vue?vue&type=script&lang=js&"
export * from "./remove-transaction-modal.vue?vue&type=script&lang=js&"
import style0 from "./remove-transaction-modal.vue?vue&type=style&index=0&id=650ad451&lang=scss&scoped=true&"
import style1 from "./remove-transaction-modal.vue?vue&type=style&index=1&id=650ad451&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650ad451",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650ad451')) {
      api.createRecord('650ad451', component.options)
    } else {
      api.reload('650ad451', component.options)
    }
    module.hot.accept("./remove-transaction-modal.vue?vue&type=template&id=650ad451&scoped=true&", function () {
      api.rerender('650ad451', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personal-employee/finance/components/remove-transaction-modal.vue"
export default component.exports